export class BrowserLanguage {
    static GetCurrentLanguage(): string {
        return (navigator.languages && navigator.languages.length) ? navigator.languages[0] :
        window.navigator.userLanguage || navigator.language || navigator.browserLanguage || 'es';
    }
}
